const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'content',
    label: 'Content'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'STRING',
    key: 'pageTitle',
    label: 'Page Title',
    default: 'FAQ'
  }
];

const defaultProps = {
  slots: [
    {
      slotId: 'menu-bar',
      components: [
        {
          widgetId: 'MenuBar',
          props: {
            second_set: [
              {
                subnav: [
                  {
                    label: 'Contact Us',
                    url: '/contact-us'
                  }, {
                    label: 'FAQ',
                    url: '/faq'
                  }
                ],
                label: 'Support'
              },
              {
                label: 'Sign In',
                url: '/login',
                loggedInLabel: 'My FF'
              }
            ],
            first_set: [
              {
                subnav: [],
                label: 'FF 91',
                url: '/ff-91'
              }, {
                subnav: [],
                label: 'FFZERO1',
                url: '/ffzero1'
              }, {
                subnav: [],
                label: 'Formula E',
                url: '/formula-e'
              }, {
                subnav: [],
                label: 'FUTURESIGHT',
                url: '/futuresight'
              }, {
                subnav: [
                  {
                    label: 'Our Company',
                    url: '/our-company'
                  }, {
                    label: 'Formula E',
                    url: '/formula-e'
                  }, {
                    label: 'Careers',
                    url: '/careers'
                  }, {
                    label: 'Press Room',
                    url: '/press'
                  }
                ],
                url: '',
                label: 'About Us'
              }
            ],
            logo_link: '/',
            color_theme: 'LIGHT',
            scroll_effect: false
          }
        }
      ]
    }, {
      slotId: 'content',
      components: []
    }, {
      slotId: 'footer',
      components: [
        {
          widgetId: 'Footer',
          props: {
            items: [
              { url: '/sitemap', label: 'Sitemap' },
              { url: '/privacy-policy', label: 'Privacy & Legal' },
              { url: '/contact-us', label: 'Contact Us' }
            ],
            regions: [
              {
                value: 'US',
                imgUrl: 'https://genesis-cdn.ff.com/icon-en.png'
              }, {
                value: 'CN',
                imgUrl: 'https://genesis-cdn.ff.com/icon-china.png'
              }
            ],
            socialLinks: [
              { url: 'https://linkedin.com', icon: 'ff-icon-social-linkedin' },
              { url: 'https://youtube.com', icon: 'ff-icon-social-youtube' },
              { url: 'https://twitter.com', icon: 'ff-icon-social-twitter' },
              { url: 'https://facebook.com', icon: 'ff-icon-social-facebook' },
              { url: 'https://instagram.com', icon: 'ff-icon-social-instagram' }
            ],
            copyright: {
              text: 'Faraday&Future Inc. The Faraday Future name and logo are trademarks of Faraday&Future Inc. All rights reserved.'
            }
          }
        }
      ]
    }
  ],
  templateSettings: {
    pageTitle: 'FAQ'
  }
};

export default {
  id: 'HeaderFlexContent',
  name: 'Header with Flex Content Slot',
  creator: 'Victor Bello',
  updatedBy: 'Victor Bello',
  createdAt: 1505938843783,
  updatedAt: 1505938843783,
  slots,
  templateSettings,
  defaultProps
};
